import { Component, inject } from '@angular/core';
import { DatePipe } from '@angular/common';
import { TableModule, TableRowSelectEvent } from 'primeng/table';
import { TableRowDirective } from '@core/primevue/directives/table-row.directive';
import { PrimeTemplate } from 'primeng/api';
import { MedarbejdereService } from '@features/letpensiondk/letpensiondk-medarbejdere/medarbejdere.service';
import { Checkbox } from 'primeng/checkbox';
import { FormsModule } from '@angular/forms';
import { IconField } from 'primeng/iconfield';
import { InputIcon } from 'primeng/inputicon';
import { InputText } from 'primeng/inputtext';
import { Toolbar } from 'primeng/toolbar';

@Component({
  selector: 'app-letpensiondk-medarbejdere-list',
  imports: [
    DatePipe,
    PrimeTemplate,
    TableModule,
    TableRowDirective,
    Checkbox,
    FormsModule,
    IconField,
    InputIcon,
    InputText,
    Toolbar
  ],
  templateUrl: './letpensiondk-medarbejdere-list.component.html',
  styleUrl: './letpensiondk-medarbejdere-list.component.css'
})
export class LetpensiondkMedarbejdereListComponent {
  medarbejdereService = inject(MedarbejdereService);

  data = this.medarbejdereService.datasource.data;

  onRowSelect(e: TableRowSelectEvent) {
    this.medarbejdereService.selectMedarbejder(e.data);
  }

}
